<template>
  <b-container
    fluid
    class="mb-5"
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <div class="form-group">
            <label>Filter By Cluster</label>
            <v-select
              v-model="selectedClusterSearch"
              :options="filterClusters"
              placeholder="Select Cluster"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Distribution
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-table
            ref="table"
            hover
            responsive
            class="mt-2"
            :per-page="tableSettings.perPage"
            :current-page="tableSettings.currentPage"
            :items="myProvider"
            :fields="tableSettings.fields"
            :sort-by.sync="tableSettings.sortBy"
            :sort-desc.sync="tableSettings.sortDesc"
            :sort-direction="tableSettings.sortDirection"
            :filter="tableSettings.filter"
            :filter-included-fields="tableSettings.filterOn"
            show-empty
          >
            <template #cell(index)="data">
              {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index +
                1)

              }}
            </template>

            <template #cell(active)="data">
              {{ data.item.active === 1 ? "Yes" : "No" }}
            </template>

            <template #cell(actions)="row">
              <div class="text-nowrap">
                <b-button
                  size="sm"
                  @click="onShowEditForm(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>
          </b-table>
          <b-row>
            <b-col
              cols="12"
              sm="6"
            >
              <div class="w-100 w-sm-25 mb-2 sm-mb-2">
                <b-select
                  v-model="tableSettings.perPage"
                  :options="tableSettings.pageOptions"
                  size="sm"
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="tableSettings.currentPage"
                :total-rows="tableSettings.totalRows"
                :per-page="tableSettings.perPage"
                first-number
                last-number
                pills
                prev-text="Prev"
                next-text="Next"
                aria-controls="table"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-distribution-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      class="mb-5"
      @ok="onConfirmSubmit"
      @show="onShowModalForm"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >
          <Input
            initial-name="Distribution Code"
            initial-id-input="distribution_code"
            initial-input-type="text"
            :initial-input-value="distribution.distribution_code"
            :initial-rules="{ required: true }"
            @changeValue="onChangeValue"
          />
          <Input
            initial-name="Distribution Name"
            initial-id-input="distribution_name"
            initial-input-type="text"
            :initial-input-value="distribution.distribution_name"
            :initial-rules="{ required: true }"
            @changeValue="onChangeValue"
          />
          <ValidationProvider
            #default="{ errors }"
            name="cluster"
            vid="cluster"
            rules="required"
          >
            <b-form-group>
              <label for="cluster">Cluster</label>
              <v-select
                id="cluster"
                v-model="selectedCluster"
                :options="clusters"
                :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                placeholder="Select Cluster"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>

          </ValidationProvider>
          <div
            v-if="editMode && distribution.id !== 0"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="distribution.active"
              name="is_active"
              value="1"
              unchecked-value="0"
            >
              Is Active?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          @click="ok()"
        >
          {{ editMode ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { DistributionService, AxiosError, ListService } from '@/services'
import formatter from '@/mixins/formatter'
import Input from '@/components/FormInput/InputType'

export default {
  name: 'AdminDistributions',

  middleware: ['auth', 'marketing-officer'],

  components: {
    Input
  },

  metaInfo () {
    return {
      title: 'Distributions'
    }
  },

  mixins: [formatter],

  data () {
    return {
      isBusy: true,
      editMode: false,
      distribution: {
        id: 0,
        distribution_code: '',
        distribution_name: '',
        active: true,
        cluster: null
      },
      clusters: [],
      selectedCluster: [],
      selectedClusterSearch: [],
      filter: {
        cluster: 'All'
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'cluster_name', sortable: true },
          { key: 'distribution_code', sortable: true },
          { key: 'distribution_name', sortable: true },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.editMode ? 'Edit Distribution' : 'Add Distribution'
    },
    filterClusters () {
      return [{ value: 'All', label: 'All' }].concat(this.clusters)
    }
  },

  watch: {
    'selectedCluster' ({ value }) {
      this.distribution = { ...this.distribution, cluster: value }
    },
    'selectedClusterSearch' ({ value }) {
      this.filter = { cluster: value }
      this.$refs.table.refresh()
    }

  },

  mounted () {
    core.index()
    this.getClusters()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await DistributionService.get(`page=${ctx.currentPage}&per_page=${ctx.perPage}&sort=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&filter_text=${ctx.filter}&filter_cluster=${this.filter.cluster}`)
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getClusters () {
      await ListService.getClusters().then(({ data }) => {
        this.clusters = data.map(({ id, cluster_name }) => {
          return { value: id, label: cluster_name }
        })
      })
    },

    onClusterFilterChange () {
      this.$refs.table.refresh()
    },

    onShowModalForm () {
      if (!this.editMode) {
        this.distribution.id = 0
        this.distribution.distribution_code = ''
        this.distribution.distribution_name = ''
        this.distribution.cluster = null
        this.distribution.active = true
        this.selectedCluster = []
      }
    },

    onShowAddForm () {
      this.editMode = false
      this.$bvModal.show('modal-distribution-form')
    },

    onShowEditForm (row) {
      this.editMode = true
      const { id, distribution_code, distribution_name, active, cluster_id } = row
      this.distribution = { id, distribution_code, distribution_name, active, cluster: cluster_id }
      this.filterByClusterId(cluster_id)
      this.$bvModal.show('modal-distribution-form')
    },

    filterByClusterId (id) {
      const filterByCluster = this.clusters?.filter(el => el.value === id)
      this.selectedCluster = { value: filterByCluster[0]?.value || 0, label: filterByCluster?.[0]?.label || '' }
    },

    async onConfirmSubmit (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          if (!this.editMode) {
            this.$swal.fire({
              title: 'Are you sure want to add this record ?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#06C270',
              confirmButtonText: 'Submit',
              cancelButtonColor: '#FF2929',
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return this.onSubmitPostForm()
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })
          } else {
            this.$swal.fire({
              title: 'Are you sure want to update this record ?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#06C270',
              confirmButtonText: 'Update',
              cancelButtonColor: '#FF2929',
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return this.onSubmitPutForm()
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })
          }
        } else {
          this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger'
          })
        }
      })
    },

    async onSubmitPostForm () {
      this.isBusy = true
      await DistributionService.post(this.distribution).then(response => {
        this.$bvModal.hide('modal-distribution-form')
        this.isBusy = false
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
          confirmButtonColor: '#06C270',
          confirmButtonText: 'Dismiss'
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(error => {
        if (error instanceof AxiosError) {
          if (error.code === 422) {
            this.$refs.form.setErrors(error.message)
          }
        }
        this.isBusy = false
      })
    },

    async onSubmitPutForm () {
      this.isBusy = true
      await DistributionService.put(this.distribution).then(response => {
        this.$bvModal.hide('modal-distribution-form')
        this.isBusy = false
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
          confirmButtonColor: '#06C270',
          confirmButtonText: 'Dismiss'
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(error => {
        if (error instanceof AxiosError) {
          if (error.code === 422) {
            this.$refs.form.setErrors(error.message)
          }
        }
        this.isBusy = false
      })
    },

    onChangeValue (value, name) {
      this.distribution[name] = value
    }
  }
}
</script>
